import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { AnimationsModule } from '../../animations/animations.module';

import { SidebarLeftToggleDirective } from './sidebar-left.directive';
import { SidebarLeftComponent } from './sidebar-left.component';
export class SidebarLeftModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, RouterModule, AnimationsModule],
    exports: [SidebarLeftComponent],
    declarations: [SidebarLeftToggleDirective, SidebarLeftComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SidebarLeftModule_tsickle_Closure_declarations() {
/** @type {?} */
SidebarLeftModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SidebarLeftModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
